import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { detectIncognito } from 'detectincognitojs';
import { useEffect, useState } from 'react';
import useMountedState from 'react-use/lib/useMountedState';
import { getBooleanString } from '../../../../utils/utils';
import { DebugItemContainer } from './debugItemContainer';
/**
 * Detects and outputs whether incognito / private browser mode is detected.
 */
export const PrivateBrowserDebugItemContainer = () => {
    const [isPrivate, setIsPrivate] = useState();
    const isMounted = useMountedState();
    useEffect(() => {
        async function effect() {
            const { isPrivate } = await detectIncognito();
            if (!isMounted()) {
                return;
            }
            setIsPrivate(isPrivate);
        }
        effect();
    }, [isMounted]);
    return _jsx(DebugItemContainer, { title: 'PBM', value: getBooleanString(isPrivate) });
};
